import { render, staticRenderFns } from "./MdPatientVitalSingOutCome.vue?vue&type=template&id=8e58d1c2&"
import script from "./MdPatientVitalSingOutCome.vue?vue&type=script&lang=js&"
export * from "./MdPatientVitalSingOutCome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports